var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',{staticClass:"mt-30 mb-60 md-mt-50 md-mb-90",attrs:{"width":_vm.row.width}},[_c('carousel',{staticClass:"md-pb-flx-carousel",class:{'pb-ar-sqr bg-gray-200 md-bg-transp': _vm.multipleImgs},attrs:{"images":_vm.row.images}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }